import { render, staticRenderFns } from "./LwaRedirect.vue?vue&type=template&id=3cec12b4&"
import script from "./LwaRedirect.vue?vue&type=script&lang=js&"
export * from "./LwaRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports